import { useTranslation } from '@web_opxp/features';

interface ITrainingCalendarDayProps {
  weekDay: number;
  goal?: number;
  exercisesDone?: number;
  isToday?: boolean;
  onClick?: () => void;
}

export default function TrainingCalendarDay({
  weekDay,
  goal,
  exercisesDone,
  isToday,
  onClick,
}: Readonly<ITrainingCalendarDayProps>) {
  const { t } = useTranslation();
  const cardClasses = ['training-calendar-day'];
  let exercisesDoneLabel = '-';
  if (typeof exercisesDone !== 'undefined') {
    const goalReached = exercisesDone !== 0 && exercisesDone >= (goal ?? 0);
    cardClasses.push(goalReached ? 'completed' : 'missed');
    exercisesDoneLabel = `${exercisesDone}`;
  }
  if (isToday) {
    cardClasses.push('today');
  }
  const goalLabel = (goal ?? 0) > 0 ? `${goal}` : '-';
  return (
    <div className={cardClasses.join(' ')} onClick={onClick}>
      <p className="week-day">{t(`TrainingCalendar.WeekDayShort_${weekDay}`)}</p>
      <p>{exercisesDoneLabel}</p>
      <p>{t('TrainingCalendar.DailyGoal', { goal: goalLabel })}</p>
      {isToday ? <div className="today-badge" /> : null}
    </div>
  );
}
